import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Stack } from '@mui/material';
import { joiResolver } from '@hookform/resolvers/joi';

import { FormTextArea } from 'app-zephyr-forms';
import { setAppVersionUnavailableSchema } from 'ze-api-contract/application-v2/application-version/validation';

export type UnavailableVersionReasonFormFields = { reason: string } & Record<string, string>;

interface UnavailableVersionReasonFormProps {
  valueIsChanged: (value?: string) => void;
  formIsValid: (value: boolean) => void;
  placeholder?: string;
}

const UnavailableVersionReasonForm = ({ valueIsChanged, formIsValid }: UnavailableVersionReasonFormProps) => {
  const {
    register,
    watch,
    formState: { isValid, errors },
  } = useForm<UnavailableVersionReasonFormFields>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: joiResolver(setAppVersionUnavailableSchema),
  });

  const fieldsWatch = watch();

  useEffect(() => {
    valueIsChanged(fieldsWatch.reason);
    formIsValid(isValid);
  }, [isValid, fieldsWatch]);

  return (
    <form style={{ width: '100%' }}>
      <Stack width="100%">
        <FormTextArea id="reason" name="reason" label="Reason" register={register} errors={errors} />
      </Stack>
    </form>
  );
};

export { UnavailableVersionReasonForm };
